import { render, staticRenderFns } from "./CoverageDetailSinglePlotsList.vue?vue&type=template&id=da1ad162"
import script from "./CoverageDetailSinglePlotsList.vue?vue&type=script&setup=true&lang=ts"
export * from "./CoverageDetailSinglePlotsList.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports